import type { MetadataFieldDescriptor, MetadataFields } from '../../MetadataFields.js'
import type { VisualizationSampleContainer } from '../../VisualizationSampleContainer.js'

export type CategorizedFields = {
  unused: Record<string, MetadataFieldDescriptor>
  singleValued: Record<string, MetadataFieldDescriptor>
  other: Record<string, MetadataFieldDescriptor>
}

function isPrimitive(value: unknown): value is string | number | boolean | undefined {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === undefined
}

export function categorizeFields(metadataFields: MetadataFields, samples: VisualizationSampleContainer[]): CategorizedFields {
  const unused: Record<string, MetadataFieldDescriptor> = {}
  const singleValued: Record<string, MetadataFieldDescriptor> = {}
  const other: Record<string, MetadataFieldDescriptor> = {}

  for (const [fieldKey, descriptor] of Object.entries(metadataFields)) {
    const values = samples.map((s) => (descriptor.comparisonKey ? descriptor.comparisonKey(s) : descriptor.getter(s)))

    for (const value of values) {
      if (!isPrimitive(value)) {
        throw new Error(`Field "${fieldKey}" returned non-primitive value: ${JSON.stringify(value)}`)
      }
    }

    const definedValues = values.filter((v) => v !== undefined)

    if (definedValues.length === 0) {
      unused[fieldKey] = descriptor
    } else {
      const unique = new Set(definedValues)
      if (unique.size === 1) {
        singleValued[fieldKey] = descriptor
      } else {
        other[fieldKey] = descriptor
      }
    }
  }

  return { unused, singleValued, other }
}
